import React from "react";
import loadable from '@loadable/component';

const NotFound = loadable(() => import('../components/NotFound/NotFound'));

const NotFoundPage = () => <NotFound />

export default NotFoundPage
